import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import Modal from "react-modal";
import classNames from "classnames/bind";
import style from "./index.module.css";
import Select, { components } from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getCampaignQuery, CampaignType } from '../../api/newApi/getCampaignQuery';
import axios from 'axios';
import './index.module.css';

const cx = classNames.bind(style);
interface StudentIDVerifyModelProps {
    isOpen: boolean;
    handleClose: () => void;
    cu_id: string;
}
interface FormState {
    schoolOption: string | number;
    email: string;
    agree: boolean;
    agreePersonalData: boolean;
    agreeTerms: boolean;
}

interface ErrorState {
    schoolOption?: string;
    email?: string;
    agree?: string;
    agreePersonalData?: string;
    agreeTerms?: string;
}
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

const StudentIDVerifyModel: React.FC<StudentIDVerifyModelProps> = ({
    isOpen,
    handleClose,
}) => {
    const [formState, setFormState] = useState<FormState>({
        schoolOption: "",
        email: "",
        agree: false,
        agreePersonalData: false,
        agreeTerms: false,
    });
    const [errors, setErrors] = useState<ErrorState>({});
    const [showFirstVerifyModal, setShowFirstVerifyModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showEmailUsedModal, setShowEmailUsedModal] = useState(false); // Modal for '1111' error
    const [showFrequentRequestModal, setShowFrequentRequestModal] = useState(false); // Modal for '2222' error
    const [schoolOptions, setSchoolOptions] = useState<{ label: string, value: string }[]>([]);

    // 處理表單輸入變更
    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target;
        if (type === "checkbox" && e.target instanceof HTMLInputElement) {
            const { checked } = e.target;
            setFormState((prevState) => ({
                ...prevState,
                [name]: checked,
            }));
        } else {
            setFormState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };
    // 驗證表單輸入
    const validateForm = () => {
        const newErrors: ErrorState = {};
        const emailRegex = /^[^\s@]+@.*\.edu\.tw$/; //結尾一定要edu.tw 
        // const emailRegex = /^[^\s@]+@gmail\.com$/; // 限制只能用 gmail 信箱(權證測試用)

        if (!formState.schoolOption) {
            newErrors.schoolOption = "*請選擇在讀之大專院校";
        }
        if (!emailRegex.test(formState.email)) {
            newErrors.email = "*請輸入學校E-mail 格式錯誤";
        }
        if (!formState.agree) {
            newErrors.agree = "*尚未勾選";
        }
        if (!formState.agreePersonalData) {
            newErrors.agreePersonalData = "*尚未勾選";
        }
        if (!formState.agreeTerms) {
            newErrors.agreeTerms = "*尚未勾選";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // 提交表單處理
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            setShowFirstVerifyModal(true);
        }
    };

    // 真正提交資料
    const performSubmit = async () => {
        try {
            if (!formState.email) {
                toast.error("請輸入學校 Email");
                return;
            }

            const campaignResponse = await getCampaignQuery(axiosInstance);
            if (campaignResponse?.error === "0000") {
                const cu_id = campaignResponse?.cu_id;
                const campaigns = campaignResponse?.campaign as CampaignType[];
                const code = campaigns?.[1]?.code; //暫時寫死來抓campaigns第二個
                if (!cu_id || !code) {
                    console.error('cu_id 或 code 不存在');
                    toast.error('cu_id 或 code 不存在');
                    return;
                }

                const requestData = {
                    cu_id,
                    mail: formState.email,
                    code,
                    school_id: formState.schoolOption,
                };
                const response = await fetch('/api2/Invitation/MailVerifyApply', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(requestData),
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('API 錯誤:', response.status, errorText);
                    toast.error(`提交失敗: ${response.status}`);
                    return;
                }

                const result = await response.json();

                if (result.err === '8015') {
                    setShowEmailUsedModal(true);
                } else if (result.err === '8016') {
                    setShowFrequentRequestModal(true);
                } else if (result.err === '0000') {
                    setShowSuccessModal(true);
                    toast.success("驗證信已寄出！");
                    setFormState({
                        schoolOption: "",
                        email: "",
                        agree: false,
                        agreePersonalData: false,
                        agreeTerms: false,
                    });
                } else {
                    toast.error(result.message);
                }
            } else {
                toast.error(`獲取 cu_id 失敗: ${campaignResponse?.error || "未知錯誤"}`);
            }
        } catch (error) {
            toast.error('提交時出錯，請稍後再試');
        }
    };


    // 首次驗證模態窗關閉處理
    const handleFirstVerifyClose = () => {
        setShowFirstVerifyModal(false);
        performSubmit(); // 送出
    };

    // 成功模態窗關閉處理
    const handleSuccessModalClose = () => {
        setShowSuccessModal(false);
        handleClose();
    };
    // 箭頭大小和顏色
    const DropdownIndicator = (props: any) => {
        return (
            <components.DropdownIndicator {...props}>
                <span style={{
                    color: '#021D5F',  // 自定義箭頭顏色
                    fontSize: '20px',   // 調整箭頭大小
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none'
                }}>
                    ▼
                </span>
            </components.DropdownIndicator>
        );
    };

    const customStyles = {
        control: (base: any) => ({
            ...base,
            backgroundColor: '#fff',
            borderColor: '#ced4da',
            padding: '5px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '##021D5F',
            },
            height: '48px',
            minHeight: '40px',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: '#6c757d',
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            padding: '0',
            width: '40px',
            display: 'flex',
            justifyContent: 'center',
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: 'transparent',
        }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: '#f8f9fa',
            color: '#000',
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isFocused ? '#e9ecef' : '#fff',
            color: '#000',
            '&:hover': {
                backgroundColor: '#e9ecef',
            },
        }),
    };
    //加載 大專院校api
    useEffect(() => {
        const fetchSchoolList = async () => {
            try {
                const response = await axiosInstance.post("/api2/Warrant/SchoolList");
                const { data, err } = response.data;

                if (err === "0000") {
                    const schoolList = data.map((school: { id: number; name: string }) => ({
                        label: school.name, // react-select 需要 label
                        value: school.id,
                    }));
                    setSchoolOptions(schoolList);
                } else {
                    toast.error("加載失敗ＡＰＩ");
                }
            } catch (error) {
                toast.error("Error fetching school list");
            }
        };
        fetchSchoolList();
    }, []);


    const handleSelectChange = (selectedOption: { label: string; value: number } | null) => {
        setFormState((prevState) => ({
            ...prevState,
            schoolOption: selectedOption ? selectedOption.value : "",
        }));
    };


    return (
        <>
            <Modal
                isOpen={isOpen}
                contentLabel=""
                onRequestClose={handleClose}
                className={cx("Modal")}
                overlayClassName="Overlay"
                shouldCloseOnOverlayClick={false}
                ariaHideApp={false}
            >
                <div>
                    <div className={cx("modalTitleContainer")}>
                        <div className={cx("modalTitle")}>學生身分驗證</div>
                        <div className={cx("modalRight")}>
                            <button className={cx("modalCloseButton")} onClick={handleClose}>
                                q   wq  wq      ty                            </button>
                        </div>
                    </div>
                    <div className={cx("modalContent")}>
                        <p className={cx("description")} style={{ color: "#fff", fontSize: "22px" }}>
                            請輸入驗證資料
                        </p>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Col sm="12">
                                    {/* 使用自定義樣式的 react-select */}
                                    <Select
                                        options={schoolOptions}
                                        value={schoolOptions.find(option => option.value === formState.schoolOption)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption as { label: string; value: number } | null)}
                                        placeholder="選擇在讀之大專院校"
                                        isClearable
                                        styles={customStyles} // 應用自定義樣式
                                        components={{ DropdownIndicator }} // 使用自定義的箭頭圖標
                                    />
                                </Col>
                            </Form.Group>
                            {errors.schoolOption && <div className={cx("error")}>{errors.schoolOption}</div>}
                            {/* 增加間距 */}
                            <Form.Group as={Row} className="mb-3">
                                <Col sm="12">
                                    <Form.Control
                                        type="email"
                                        placeholder="學校Email"
                                        name="email"
                                        value={formState.email}
                                        onChange={(e) => handleInputChange(e)}
                                        style={{ marginTop: '10px', height: '48px' }} // 增加與 select 的間距
                                    />
                                    {errors.email && <div className={cx("error")}>{errors.email}</div>}
                                </Col>
                            </Form.Group>
                            {/* 第一個複選框 */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="4"></Form.Label>
                                <Col sm="12" className={cx("formCheck")}>
                                    <Form.Check
                                        type="checkbox"
                                        name="agree"
                                        checked={formState.agree}
                                        onChange={handleInputChange}
                                        label={
                                            <>
                                                <span>
                                                    活動僅限國內在校之大專院校學生參與，本人確認符合相關參與資格。
                                                </span>
                                                <span style={{ color: "yellow" }}>如獲獎，需提供學生身分之證明資料。</span>
                                            </>
                                        }
                                    />
                                    {errors.agree && <div className={cx("error")}>{errors.agree}</div>}
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="4"></Form.Label>
                                <Col sm="12" className={cx("formCheck")}>
                                    <Form.Check
                                        type="checkbox"
                                        name="agreePersonalData"
                                        checked={formState.agreePersonalData}
                                        onChange={handleInputChange}
                                        label={
                                            <>
                                                同意 <span
                                                    onClick={() => {
                                                        (window.parent as any).showTradEventModalId()
                                                    }}
                                                    style={{ textDecoration: "underline", cursor: "pointer", color: "#fff" }}
                                                >
                                                    《活動辦法》
                                                </span>內容。
                                            </>
                                        }
                                    />
                                    {errors.agreePersonalData && <div className={cx("error")}>{errors.agreePersonalData}</div>}
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="4"></Form.Label>
                                <Col sm="12" className={cx("formCheck")}>
                                    <Form.Check
                                        type="checkbox"
                                        name="agreeTerms"
                                        checked={formState.agreeTerms}
                                        onChange={handleInputChange}
                                        label={
                                            <>
                                                同意 <span
                                                    onClick={() => {
                                                        (window.parent as any).showTradEventModalId()
                                                    }}
                                                    style={{ textDecoration: "underline", cursor: "pointer", color: "#fff" }}
                                                >
                                                    《蒐集個人資料告知事項與同意書》
                                                </span>內容。

                                            </>
                                        }
                                    />
                                    {errors.agreeTerms && <div className={cx("error")}>{errors.agreeTerms}</div>}
                                </Col>
                            </Form.Group>
                            <div className={cx("button-group")}>
                                <Col style={{ display: "inline-grid" }}>
                                    <Button type="submit" className={cx("order-button")}>
                                        送出
                                    </Button>
                                </Col>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal>
            {/* 首次驗證 */}
            <Modal
                isOpen={showFirstVerifyModal}
                contentLabel="Email 確認"
                onRequestClose={() => setShowFirstVerifyModal(false)}
                className={cx("Modal")}
                overlayClassName="Overlay"
                shouldCloseOnOverlayClick={false}
                ariaHideApp={false}
            >
                <div className={cx("modalTitleContainer")}>
                    <div className={cx("modalRight")}>
                        <button className={cx("modalCloseButton")} onClick={() => setShowFirstVerifyModal(false)}>
                            <span className={cx("modalCloseButtonFont")}>&times;</span>
                        </button>
                    </div>
                </div>

                <div className={cx("modalContent")}>
                    <div className={cx("description")} style={{ fontSize: "18px", color: "#FFF" }}>
                        請再次確認學校 Email 是否正確
                    </div>
                    <p className={cx("description")} style={{ fontSize: "18px", color: "#FFF" }}>
                        E-mail: {formState.email}
                    </p>
                    <p className={cx("error")} style={{ textAlign: "center", fontWeight: "bold" }}>*如輸入錯誤E-mail，將無法收到驗證信
                    </p>
                    <div className={cx("button-group")}>
                        <Button className={cx("order-button")} style={{ width: '100px' }} onClick={handleFirstVerifyClose}>
                            送出
                        </Button>
                        <Button className={cx("order-button-cancel")} style={{ width: '100px' }} onClick={() => setShowFirstVerifyModal(false)}>
                            取消
                        </Button>
                    </div>
                </div>
            </Modal>
            {/* 驗證信成功 */}
            <Modal
                isOpen={showSuccessModal}
                contentLabel="提交成功"
                onRequestClose={handleSuccessModalClose}
                className={cx("Modal")}
                overlayClassName="Overlay"
                shouldCloseOnOverlayClick={false}
                ariaHideApp={false}
            >
                <div className={cx("modalTitleContainer")}>
                    <div className={cx("modalRight")}>
                        <button className={cx("modalCloseButton")} onClick={handleSuccessModalClose}>
                            <span className={cx("modalCloseButtonFont")}>&times;</span>
                        </button>
                    </div>
                </div>
                <div className={cx("modalContent")}>
                    <p style={{ fontSize: "20px", color: "#FFF", textAlign: "center" }}>
                        驗證信發送成功！ <br /> 請至驗證信中點擊驗證連結
                    </p>
                    <div className={cx("button-group")}>
                        <Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button className={cx("order-button")} onClick={handleSuccessModalClose}>
                                確定
                            </Button>
                        </Col>
                    </div>
                </div>
            </Modal>
            {/* 信箱已被使用 */}
            <Modal
                isOpen={showEmailUsedModal}
                contentLabel="Email 已被使用"
                onRequestClose={() => setShowEmailUsedModal(false)}
                className={cx("Modal")}
                overlayClassName="Overlay"
                shouldCloseOnOverlayClick={false}
                ariaHideApp={false}
            >
                <div className={cx("modalTitleContainer")}>
                    <div className={cx("modalRight")}>
                        <button className={cx("modalCloseButton")} onClick={() => setShowEmailUsedModal(false)}>
                            <span className={cx("modalCloseButtonFont")}>&times;</span>
                        </button>
                    </div>
                </div>
                <div className={cx("modalContent")}>
                    <p style={{ fontSize: "22px", color: "#FFF", textAlign: "center" }}>
                        驗證信發送失敗！
                        <br />
                        該學校E-mail已被使用
                    </p>
                    <div className={cx("button-group")}>
                        <Button className={cx("order-button")} onClick={() => setShowEmailUsedModal(false)}>
                            關閉
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* 信箱驗證過於頻繁 */}
            <Modal
                isOpen={showFrequentRequestModal}
                contentLabel="請稍後再試"
                onRequestClose={() => setShowFrequentRequestModal(false)}
                className={cx("Modal")}
                overlayClassName="Overlay"
                shouldCloseOnOverlayClick={false}
                ariaHideApp={false}
            >
                <div className={cx("modalTitleContainer")}>
                    <div className={cx("modalRight")}>
                        <button className={cx("modalCloseButton")} onClick={() => setShowFrequentRequestModal(false)}>
                            <span className={cx("modalCloseButtonFont")}>&times;</span>
                        </button>
                    </div>
                </div>
                <div className={cx("modalContent")}>
                    <p style={{ fontSize: "18px", color: "#FFF", textAlign: "center" }}>
                        驗證信發送過於頻繁，
                        <br />
                        請於五分鐘後再試
                    </p>
                    <div className={cx("button-group")}>
                        <Button className={cx("order-button")} onClick={() => setShowFrequentRequestModal(false)}>
                            確定
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default StudentIDVerifyModel;
